import {
  PERSONAL_DATA,
  AU_IDENTIFICATION_TYPES,
} from '@/constants/personalData';
import { INSTALLATION_ADDRESS } from '@/constants/installationAddress';
import { SHIPPING_ADDRESS } from '@/constants/shippingAddress';
import { PAYMENT } from '@/constants/payment';
import { ADDITIONAL_R2R } from '@/constants/additionalR2R';
import { LINE_TYPE } from '@/constants/constant';
import {
  MOBILE_LINE_ACTIONS,
  LAND_LINE_ACTIONS,
  OPERATION,
  DELIVERY,
} from '@/constants/operation';
import { CHARACTERISTICS_TYPES } from '@/constants/pages/miMovistar';
import { ORDER_SUMMARY } from '@/constants/orderSummary';
import { getDocNumberType } from '@/utils/validators';
import getUrlParams from '@gcloud-npm/utils.common.get-url-params';
import { calculateAddress } from '@/utils/address';

export const R2R_MODALITY = {
  INCLUDED: 'incluido',
  ADDITIONAL: 'adicional',
};

export const buildProductList = (
  dispositivo = R2R_MODALITY.INCLUDED,
  recommendation = null
) => {
  const {
    productOffering,
    speedId,
    poR,
    idColorTelco,
    idCapacidadTelco,
    poN,
    poOTT,
    poLMA,
    poTV,
    bonus,
  } = {
    ...getUrlParams({
      groupByObject: false,
      allowedParams: false,
      excludeHash: true,
      currentUrl: window.location.href,
    }),
  };
  const products = {
    ...(productOffering ? { productOffering } : {}),
    ...(speedId ? { speedId } : {}),
    ...(productOffering ? { productOffering } : {}),
    ...(poR ? { poR } : {}),
    ...(idColorTelco ? { idColorTelco } : {}),
    ...(idCapacidadTelco ? { idCapacidadTelco } : {}),
    ...(poN ? { poN } : {}),
    ...(poOTT ? { poOTT } : {}),
    ...(poLMA ? { poLMA } : {}),
    ...(poTV ? { poTV } : {}),
    ...(bonus ? { bonus } : {}),
  };
  const bundles = [];
  let r2rIncluded = null;
  let r2rAdditional = null;
  let promotions = [];
  Object.keys(products).forEach((key) => {
    let item;
    switch (key) {
      case 'poR':
        if (dispositivo === R2R_MODALITY.INCLUDED) {
          r2rIncluded = {
            productOfferingId: products.poR,
            characteristics: [
              {
                id: CHARACTERISTICS_TYPES.COLOR,
                value: products.idColorTelco,
              },
              {
                id: CHARACTERISTICS_TYPES.CAPACIDAD,
                value: products.idCapacidadTelco,
              },
            ],
          };
        } else if (dispositivo === R2R_MODALITY.ADDITIONAL) {
          r2rAdditional = {
            productOfferingId: products.poR,
            characteristics: [
              {
                id: CHARACTERISTICS_TYPES.COLOR,
                value: products.idColorTelco,
              },
              {
                id: CHARACTERISTICS_TYPES.CAPACIDAD,
                value: products.idCapacidadTelco,
              },
            ],
          };
        }
        break;
      case 'productOffering': {
        const [poId, promotionId] = (productOffering || '').split(' ');
        if (poId) {
          item = {
            productOfferingId: recommendation?.telcoProductOfferingId ?? poId,
          };
          if (recommendation?.telcoCharacteristicValue) {
            item.characteristics = [
              {
                id: CHARACTERISTICS_TYPES.SPEED,
                value: recommendation.telcoCharacteristicValue,
              },
            ];
          } else if (
            (!recommendation || !recommendation.telcoCharacteristicValue) &&
            speedId
          ) {
            item.characteristics = [
              { id: CHARACTERISTICS_TYPES.SPEED, value: speedId },
            ];
          }
          bundles.push(item);
        }
        if (promotionId) {
          promotions = [{ promotionId }];
        }
        break;
      }
      case 'poN': {
        const netflixParam = products?.poN?.split('_');
        if (Array.isArray(netflixParam) && netflixParam.length === 2) {
          item = {
            productOfferingId: netflixParam.shift(),
            characteristics: [
              {
                id: CHARACTERISTICS_TYPES.OTT,
                value: netflixParam.pop(),
              },
            ],
          };
        }
        if (item) {
          bundles.push({ ...item });
        }
        break;
      }
      case 'poOTT': {
        const splitted = products.poOTT && products.poOTT.split(';');
        const otts = Array.isArray(splitted) ? splitted : [];
        otts.forEach((element) => {
          const ottParam = element?.split('_');
          if (Array.isArray(ottParam) && ottParam.length === 2) {
            item = {
              productOfferingId: ottParam.shift(),
              characteristics: [
                {
                  id: CHARACTERISTICS_TYPES.OTT,
                  value: ottParam.pop(),
                },
              ],
            };
          } else if (Array.isArray(ottParam) && ottParam.length === 1) {
            item = { productOfferingId: ottParam[0] };
          }

          if (item) {
            bundles.push({ ...item });
          }
        });
        break;
      }
      case 'poLMA': {
        const splitted = products.poLMA && products.poLMA.split(';');
        const lma = Array.isArray(splitted) ? splitted : [];
        lma.forEach((element) => {
          item = { productOfferingId: element };
          if (item) {
            bundles.push({ ...item });
          }
        });
        break;
      }
      case 'poTV': {
        const splitted = products.poTV && products.poTV.split(';');
        const tv = Array.isArray(splitted) ? splitted : [];
        tv.forEach((element) => {
          item = { productOfferingId: element };
          if (item) {
            bundles.push({ ...item });
          }
        });
        break;
      }
      case 'bonus':
        item = { productOfferingId: products.bonus };
        if (item) {
          bundles.push(item);
        }
        break;
      default:
        break;
    }
  });
  return {
    bundles,
    ...(r2rIncluded ? { r2rIncluded } : {}),
    ...(r2rAdditional ? { r2rAdditional } : {}),
    ...(promotions ? { promotions } : {}),
  };
};

// el api necesita direccion facturacion obtenida del modulo de instalacion mostrado al cliente
export const getBillingAddressInfoFromForm = (
  formData,
  isManualAddress = false
) => {
  const payload = {};
  const selectedAddress = formData[INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID]
    ?.full
    ? formData[INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID]
    : formData[INSTALLATION_ADDRESS.VERTICAL_ADDRESS.ID];

  const geographicSiteId = selectedAddress?.value || null;
  payload.billingGeographicSiteId = !isManualAddress ? geographicSiteId : null;
  payload.deliveryGeographicSiteId = !isManualAddress ? geographicSiteId : null;
  payload.billingAddress = calculateAddress(
    formData,
    INSTALLATION_ADDRESS,
    false,
    isManualAddress
  );
  payload.deliveryAddress = calculateAddress(
    formData,
    INSTALLATION_ADDRESS,
    false,
    isManualAddress
  );
  payload.lineCoverage = selectedAddress?.lineCoverage || null;

  if (!isManualAddress) {
    payload.postalCode =
      formData[INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID]?.postalCode;
    payload.zone = formData[INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID]?.full
      ? formData[INSTALLATION_ADDRESS.HORIZONTAL_ADDRESS.ID]?.zone
      : formData[INSTALLATION_ADDRESS.VERTICAL_ADDRESS.ID]?.zone;
  }
  return payload;
};
export const getDeliveryAddressInfoFromForm = (formData) => {
  let payload = {};
  if (!formData[SHIPPING_ADDRESS.KEEP_ADDRESS_CHECK.ID]) {
    payload.deliveryGeographicSiteId = formData[
      SHIPPING_ADDRESS.HORIZONTAL_ADDRESS.ID
    ]?.full
      ? formData[SHIPPING_ADDRESS.HORIZONTAL_ADDRESS.ID]?.value || null
      : formData[SHIPPING_ADDRESS.VERTICAL_ADDRESS.ID]?.value || null;
    payload.deliveryAddress = calculateAddress(formData, SHIPPING_ADDRESS);
    return payload;
  }
  const {
    billingGeographicSiteId: deliveryGeographicSiteId,
    billingAddress: deliveryAddress,
  } = getBillingAddressInfoFromForm(formData);
  payload = { deliveryGeographicSiteId, deliveryAddress };
  return payload;
};
export const transformFormDataInfoToPayload = (formData) => {
  const payload = {};
  payload.contactEmail = formData[PERSONAL_DATA.EMAIL.ID];
  payload.contactPhone = formData[PERSONAL_DATA.CONTACT_PHONE.ID]?.replace(
    /\s/g,
    ''
  );
  if (
    formData[PERSONAL_DATA.AU_IDENTIFICATION_TYPE.ID]?.value ===
    AU_IDENTIFICATION_TYPES.AU_IDENTIFICATION_TYPE_CIF.value
  ) {
    payload.documentId = formData[PERSONAL_DATA.CIF.ID];
    payload.documentType = PERSONAL_DATA.CIF.LABEL;
    payload.legalRepresentative = {
      documentId: formData[PERSONAL_DATA.DOC_NUMBER.ID]?.toUpperCase(),
      documentType: getDocNumberType(
        formData[PERSONAL_DATA.DOC_NUMBER.ID]?.toUpperCase()
      ),
      fullName: formData[PERSONAL_DATA.FULL_NAME.ID],
    };
    payload.companyName = formData[PERSONAL_DATA.COMPANY_NAME.ID];
    payload.name = null;
    payload.surname1 = null;
    payload.surname2 = null;
  } else {
    payload.documentId = formData[PERSONAL_DATA.DOC_NUMBER.ID]?.toUpperCase();
    if (payload.documentId) {
      payload.documentType = getDocNumberType(payload.documentId);
    } else {
      payload.documentType = null;
    }
    payload.name = formData[PERSONAL_DATA.NAME.ID];
    payload.surname1 = formData[PERSONAL_DATA.LAST_NAME.ID];
    payload.surname2 = formData[PERSONAL_DATA.SECOND_SURNAME.ID];
    payload.legalRepresentative = null;
    payload.companyName = null;
  }
  payload.bankAccount = formData[PAYMENT.BANK_ACCOUNT.ID]?.replace(/\s/g, '');
  payload.legalTermsAcceptance =
    formData[ORDER_SUMMARY.TERMS_AND_CONDITIONS_CHECK.ID];
  payload.mobileLinesConfiguration = formData[OPERATION.ID]
    .filter((item) => item.type === LINE_TYPE.MOBILE_LINE)
    .map((item) => ({
      id: item.id,
      mobileLineAction: item[OPERATION.ACTION_CHOICER.ID]?.value,
      simType: item[OPERATION.CARD_CHOICER.ID]?.value || 'SIM',
      mobileNumber:
        (item[OPERATION.ACTION_CHOICER.ID]?.value ===
          MOBILE_LINE_ACTIONS.PORTABILITY &&
          item[OPERATION.PORTABILITY.ID]?.replace(/\s/g, '')) ||
        null,
    }));
  payload.landLinesConfiguration = formData[OPERATION.ID]
    .filter((item) => item.type === LINE_TYPE.LAND_LINE)
    .map((item) => ({
      id: item.id,
      landLineAction: item[OPERATION.ACTION_CHOICER.ID]?.value,
      landPhoneNumber:
        (item[OPERATION.ACTION_CHOICER.ID]?.value ===
          LAND_LINE_ACTIONS.PORTABILITY &&
          item[OPERATION.PORTABILITY.ID]?.replace(/\s/g, '')) ||
        null,
    }));
  if (formData[ADDITIONAL_R2R.PAYMENTS.ID]) {
    payload.paymentIdR2RAdditional = formData[ADDITIONAL_R2R.PAYMENTS.ID];
  }
  const deliveryFormData = formData[DELIVERY.ID];
  if (deliveryFormData) {
    payload.simShippingType =
      deliveryFormData[DELIVERY.DELIVERY_METHOD.ID]?.value;
  }
  const billingAddress = getBillingAddressInfoFromForm(formData);
  return {
    ...payload,
    ...billingAddress,
  };
};
export const getAllProductNames = (shoppingCart) => {
  try {
    const { recurringPrices } = { ...shoppingCart };
    let productNames = '';
    if (Array.isArray(recurringPrices)) {
      recurringPrices.forEach((item, index) => {
        if (index === 0) {
          productNames = item?.name;
        } else {
          productNames = `${productNames};${item?.name}`;
        }
      });
    }
    return productNames;
  } catch {
    return '';
  }
};
